import { render, staticRenderFns } from "./Blocked.vue?vue&type=template&id=8224efee&scoped=true"
import script from "./Blocked.vue?vue&type=script&lang=js"
export * from "./Blocked.vue?vue&type=script&lang=js"
import style0 from "./Blocked.vue?vue&type=style&index=0&id=8224efee&prod&lang=scss"
import style1 from "./Blocked.vue?vue&type=style&index=1&id=8224efee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8224efee",
  null
  
)

export default component.exports